export const breakpoints: {
  readonly mobile: string;
  readonly tablet: string;
  readonly desktop: string;
} = {
  mobile: '767px',
  tablet: '1024px',
  desktop: '1440px',
};
